
export interface INotification {
    type: NotificationTypes;
    title?: string;
    text: string;
    timeout?: number;
    disableClose?: boolean;
    horizontalPosition? : string;
    verticalPosition? : string;
    showTimer?: boolean;
}

export enum NotificationTypes {
  Error = 'danger',
  Info = 'info',
  Warning = 'warning',
  Success = 'success',
}

export interface IFormErrorNotification {
  type: NotificationTypes;
  title?: string;
  formErrors: {controlName: string, message: string }[];
}

export interface ISnackbarData {
  alertType: NotificationTypes;
  title?: string;
  message?: string;
  extraData?: any;
}

